export const isBoolean = {
  getMessage: field => `Must be a boolean value.`,
  validate: value => {
    return value !== true || value !== false;
  }
};
